import { useTheme } from "@mui/material";

const Card = ({ title, children, style }) => {
  const theme = useTheme();
  
  return (
    <div
      style={{
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        borderRadius: "10px",
        boxShadow: theme.palette.mode === "dark" 
          ? "0 4px 20px rgba(0,0,0,0.5)" 
          : "0 4px 10px rgba(0,0,0,0.05)",
        padding: "20px",
        marginBottom: "20px",
        border: theme.palette.mode === "dark" 
          ? `1px solid ${theme.palette.divider}` 
          : "none",
        ...style,
      }}
    >
      {title && (
        <div
          style={{
            borderBottom: `1px solid ${theme.palette.divider}`,
            paddingBottom: "10px",
            marginBottom: "15px",
          }}
        >
          <h3 style={{ margin: 0, color: theme.palette.text.primary }}>{title}</h3>
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
  
